module.exports = __webpack_public_path__ + "img/coupon-popup-item-use-hen.9a5b0dc5.png";